import * as React from 'react';
import classNames from 'clsx';
import { Button } from '@cian/ui-kit';

import * as styles from './SelectionsButton.css';

export interface ISelectionsButtonProps {
  onClick: () => void;
  href: string;
  XXL?: boolean;
  secondary?: boolean;
  fullWidth?: boolean;
  placeType: string;
}

export function SelectionsButton(props: ISelectionsButtonProps) {
  const { onClick, href, XXL = false, secondary = false, fullWidth = false, placeType } = props;

  return (
    <a
      href={href}
      title={'Подобрать другой ЖК'}
      className={classNames(styles['button'], fullWidth && styles['fullWidth'])}
    >
      <Button
        onClick={onClick}
        theme={secondary ? 'fill_secondary' : 'fill_primary'}
        size={XXL ? 'M' : 'XS'}
        fullWidth={fullWidth}
        data-testid={`SelectionsButton_${placeType}`}
      >
        Подобрать другой ЖК
      </Button>
    </a>
  );
}
